import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight, Menu } from '@mui/icons-material';
import { Box, Divider, IconButton, ListItem, ListItemButton, ListItemText, Typography, } from '@mui/material';
import { useCallback, useContext, useEffect, useState, } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { DrawerHeader } from './config';
import { RouteNaming } from 'z3k-settings/routes/type';
import { getItemGroupFromPath, getItemKeyFromPath, getItemKeyRouter, } from '../../../layout/drawer/path-utils';
import { Z3KSettingsEditor } from '../../../provider/types';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { AdaptiveDrawer } from './adaptive-drawer';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { useNavigateTo } from 'shared/hooks/router';
import { getZ3kEntityById } from 'z3k-parser/lib';
export function Z3kDragDropContainer(props) {
    const { children, childrenItem, customButtons } = props;
    const isMobile = !isMediumUI();
    const navigate = useNavigate();
    const location = useLocation();
    const group_key = (location?.state?.group_key ??
        getItemGroupFromPath(location.pathname));
    const useNavigateParent = useNavigateTo('', {
        state: { group_key: group_key, item_key: null, item_id: null },
    });
    const [listSelect, setSelectList] = useState(null);
    const [drawer, onCloseDrawer, onOpenDrawer] = useBooleanState(true);
    const [selected_item_id, setSelectedItemId] = useState(null);
    const { config } = useContext(Z3KSettingsEditor);
    const findId = useCallback((item_key, item_id, findInConfig) => {
        return !item_id || !findInConfig;
    }, []);
    const findIdElement = props.findId ?? findId;
    useEffect(() => {
        const item_key = (location?.state?.item_key ??
            getItemKeyFromPath(location.pathname));
        const item_id = location?.state?.item_id;
        const [type] = getZ3kEntityById(config, item_id ?? -1);
        setSelectedItemId(item_id);
        setSelectList(item_key);
        if (item_key) {
            if (findIdElement(item_key, item_id, type != null)) {
                useNavigateParent();
                return;
            }
            onCloseDrawer();
        }
        else {
            onOpenDrawer();
        }
    }, [location, setSelectedItemId, onCloseDrawer, onOpenDrawer, getItemKeyFromPath]);
    const onClickItem = useCallback((item_key) => {
        navigate(`${item_key}`, {
            state: { group_key: group_key, item_key: item_key, item_id: null },
        });
    }, [group_key]);
    const isItemKey = getItemKeyRouter() != null;
    const allChildren = (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, children: [customButtons?.map((el, idx) => {
                return (_jsxs(Box, { children: [idx === 0 && _jsx(Divider, {}), _jsx(ListItem, { disablePadding: true, divider: true, sx: () => ({
                                transitionProperty: 'background-color, color',
                                borderBottom: 'none',
                            }), onClick: () => onClickItem(el), children: _jsxs(ListItemButton, { selected: listSelect == el, children: [_jsx(ListItemText, { primary: _jsx(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", flexGrow: 1, whiteSpace: "normal", overflow: "hidden", children: _jsx(Typography, { variant: "subtitle1", ml: 2, children: RouteNaming[el] }) }) }), _jsx(ChevronRight, {})] }) }), idx !== customButtons.length - 1 && _jsx(Divider, {}), idx == customButtons.length - 1 && !childrenItem && (_jsx(Divider, {}))] }, idx));
            }), children, childrenItem && childrenItem(selected_item_id)] }));
    return (_jsxs(Box, { display: "flex", height: "100%", overflow: "hidden", children: [isMobile ? (!isItemKey && _jsx(AdaptiveDrawer, { open: true, children: allChildren })) : (_jsx(AdaptiveDrawer, { open: drawer, header: _jsx(DrawerHeader, { children: _jsx(Box, { width: "100%", display: "flex", justifyContent: "end", children: _jsx(IconButton, { onClick: useNavigateParent, children: !drawer && _jsx(Menu, {}) }) }) }), children: allChildren })), _jsx(Box, { width: "100%", px: 2, pb: isMobile ? 3 : 0, pt: isMobile ? 1 : 8, overflow: "auto", children: _jsx(Outlet, {}) })] }));
}
